@if({
    lastUuidChanged:lastUuidChanged$|async,
    lastUuidSelected:lastUuidSelected$|async,
}; as data){
    @if(currentSale()){
        <tilby-shop-cart
              [isHidePrices]="!showPrices"
              [showAllExits]="!!currentSale()?.table_id"
              [departments]="cashregisterStateService.departments"
              [exitsArray$]="exitsArray$"
              [groupItemUuid]="activeSaleService.groupItemUuid"
              [lastUuidChanged]="data.lastUuidChanged||undefined"
              [lastUuidSelected]="data.lastUuidSelected||undefined"
              [ingredientsRemovalAffectsPrice]="ingredientsRemovalAffectsPrice"
              [sale]="currentSale()"
              [disableExitStatus]="disableExitStatus"
              [compactMode]="sideKeyboard() ? true : false"
              [priceChangeDescriptions]="priceChangeDescriptions"
              (swipeLeftHandlerEmitter)="swipeLeftHandler($event)"
              (swipeRightHandlerEmitter)="swipeRightHandler($event)"
              (longPressHandlerEmitter)="longPressHandler($event)"
              (removePriceChangeFromSaleItemEmitter)="removePriceChangeFromSaleItem($event)"
              (removePriceChangeFromSaleEmitter)="removePriceChangeFromSale($event)"
              (clickHandlerEmitter)="clickHandler($event)"
              (lastUuidChangedEmitter)="lastUuidChangedEmitterHandler($event)"
              (exitChange)="exitChange($event)"
              (sendExit)="sendExitToPrinter($event)"
              (mousedown)="enableClick()"
        >
            @if(activeSaleService.groupItemUuid){
                <ng-container MenuMode>
                    <div class="order-menu-mode tw-flex tw-justify-between tw-items-center tw-pl-3 tw-w-full tilby-frame-primary tw-sticky">
                        <span class="tw-flex" translate>CASHREGISTER.ACTIVE_SALE.MENU_MODE</span>
                        <button mat-button (click)="activeSaleService.resetGroupItemUuid()" [color]="'primary'"
                                translate="CASHREGISTER.ACTIVE_SALE.MENU_MODE_END"></button>
                    </div>
                </ng-container>
            }
            @if(isMobilePortrait()){
                <app-active-sale-header-info-wrapper Header [sale]="currentSale()" [isPaymentsState]="false"/>
            }
        </tilby-shop-cart>
    } @else {
        <div (click)="selectSaleAction()" class="tw-grid tw-h-full tw-px-5 tw-justify-center tw-items-center tw-text-center tw-text-2xl">
            <div class="tw-w-full tw-flex tw-flex-col">
                <div class="tw-text-[2vh] tw-leading-[2vh] tw-font-bold">{{ currentTime | async | tilbyDate: 'dd/MM/yyyy' }}</div>
                <div class="tw-text-[6vh] tw-leading-[6vh] tw-font-bold">{{ currentTime | async | tilbyDate: 'HH:mm' }}</div>
            </div>
            <div class="tw-flex tw-text-[2vh] tw-leading-[2vh] tw-items-center tw-justify-center tw-w-full">
                <div translate>CASHREGISTER.ACTIVE_SALE.SELECT_PRODUCT_TO_CREATE_SALE</div>
            </div>
            <div class="tw-items-end tw-w-full tw-justify-center tw-flex tw-flex-grow">
                <img class="tw-h-10" src="assets/images/tilby/Zuc_Orizz_B.svg" alt="Logo Zucchetti">
            </div>
        </div>
    }
}
